import { ThemedText } from '@/components/themed-text';
import { ThemedView } from '@/components/themed-view';

export default function ChatScreen() {
  return (
    <ThemedView className="flex-1 items-center justify-center px-8">
      <ThemedText type="subtitle" className="mb-4">
        Chat
      </ThemedText>
      <ThemedText type="muted" className="text-center">
        Your conversations will appear here.
      </ThemedText>
    </ThemedView>
  );
}
